// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Gjkdc","content":"styles_content__P1iiy"};